import validateForm from './formValidator';
import validateField from './fieldValidator';
import validatePage from './pageValidator';
import helper from './helper';
export default {
  validatePage: validatePage,
  validateForm: validateForm,
  validateField: validateField,
  helper: helper
};